import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=0990e0e1"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports